import styled from "styled-components";

export const Input = styled.input`
  background: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 9px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 1em;
  width: ${(props) => props.width};
  line-height: 18px;
  margin: 0.625em 0;
  display: flex;
  height: 2.5em;
  width: 19.6em;
  color: #4a4a4a;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 0.625em auto;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
  }
`;
export const MainSection = styled.div`
  display: flex;
  margin-left: 6%;

  justify-content: center;
  height: 80vh;
  padding: 3.75em 10%;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    display: block;
    align-items: center;
    margin: 0 10%;
    height: auto;
    padding: 0%;
  }
`;
export const RegisterSection = styled.div`
  display: block;
  flex: 1;
  padding-left: 11.5%;

  form {
    width: 100%;
  }
  h2 {
    font-size: 1.8em;
    font-weight: 700;
  }
  .bold {
    font-weight: 700;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    padding-left: 0%;
    display: flex;
  }
`;
export const ImageSection = styled.div`
  flex: 1;
  text-align: center;

  p {
    margin-right: 30%;
    margin-left: 0%;
    font-size: 1em;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    p {
      margin-right: 0%;
      margin-left: 0%;
    }
    width: 100%;
    padding: 0;
    margin-bottom: 5%;
  }
`;
export const Image = styled.div`
  margin: 0%;
  margin-bottom: 0%;
  width: 22em;
  margin-left: 0;
  img {
    margin: 0%;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: -7% auto;
    width: 22em;
    height: 22em;
    img {
      object-fit: contain;
    }
  }
  @media (max-width: ${({ theme }) => theme.mobile.xxs}) {
    margin: -7% auto;
    width: 15em;
    height: 15em;
  }
`;
